import { z } from 'zod';
import { brandSchema } from './brand.js';
/**
 * JSON Schema (draft 2020-12) dell'oggetto brand, derivato dal validatore.
 *
 * È lo stesso `brandSchema` che decide cosa passa all'import, quindi non può
 * divergere da esso: tipi, enumerazioni, intervalli numerici, pattern e campi
 * obbligatori sono gli stessi. Due cose però non ci stanno, e vanno dette a
 * chi lo usa:
 *
 * - le regole [CRITICA] fra campi (stelle in percentuale, propagazione N.D.,
 *   coerenza del danno reputazionale, `basicLinkRate` solo su Trustpilot…)
 *   sono `superRefine` e uno schema JSON non le esprime: valgono comunque
 *   all'import;
 * - lo schema descrive l'**input**: le normalizzazioni applicate dopo (em
 *   dash, codice eseguibile) non cambiano la forma.
 *
 * `unrepresentable: 'any'` serve per i campi con trasformazione (`prose`,
 * `htmlBlock`): con `io: 'input'` restano stringhe con il loro tetto.
 */
export function brandJsonSchema() {
    const schema = z.toJSONSchema(brandSchema, {
        target: 'draft-2020-12',
        io: 'input',
        unrepresentable: 'any',
    });
    return {
        $schema: schema['$schema'],
        $id: 'https://app.fametrue.com/schema/brand.json',
        title: 'Fametrue — oggetto brand',
        description: "Unità di import del pannello di amministrazione (Specifica JSON v2.4). Le regole [CRITICA] di coerenza fra campi non sono esprimibili qui e vengono comunque verificate all'import.",
        ...Object.fromEntries(Object.entries(schema).filter(([k]) => k !== '$schema')),
    };
}
//# sourceMappingURL=json-schema.js.map